import { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getAuthenticationSession } from "../../actions/auth/getAuthenticationSession";
import { getRequestStates } from "../../selectors";
import { getAllowedMethods } from "../../reducers/auth/auth.selector";
import { AUTHENTICATION_SESSION_GET_REQUEST_KEY } from "../../constants";
export const useGetAuthenticationSession = () => {
  const data = useSelector(getAllowedMethods);

  const getAuthenticationSessionRequestState = state => getRequestStates(state, AUTHENTICATION_SESSION_GET_REQUEST_KEY);

  const {
    error,
    isFetching,
    isSuccess
  } = useSelector(getAuthenticationSessionRequestState);
  const dispatch = useDispatch();

  const execute = () => {
    dispatch(getAuthenticationSession());
  };

  return {
    data,
    error,
    isLoading: isFetching,
    isSuccess,
    execute: useCallback(execute, [dispatch])
  };
};